// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mWqn0AqAzCpYDdasyz_r{background:var(--secondary-200);border:0;height:1px;margin:0;padding:0;width:100%}`, "",{"version":3,"sources":["webpack://./src/shared/components/Divider/Divider.module.css"],"names":[],"mappings":"AACA,sBAKE,+BAAA,CACA,QAAA,CAJA,UAAA,CAEA,QAAA,CADA,SAAA,CAFA,UAKA","sourcesContent":["@import \"src/stylesheets/helpers/breakpoints\";\n.divider {\n  width: 100%;\n  height: 1px;\n  padding: 0;\n  margin: 0;\n  background: var(--secondary-200);\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `mWqn0AqAzCpYDdasyz_r`
};
export default ___CSS_LOADER_EXPORT___;
